import Styled from "styled-components";

const Legend = Styled.legend`
  text-align: left;
`;

export default Legend;
